import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from '@/hooks/useReducedMotion';

/**
 * Mouse-follow violet/blue radial glow.
 * Mount inside a relatively-positioned section. Glow tracks cursor.
 */
export function MouseGlow({ className = '', intensity = 0.35 }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  useEffect(() => {
    const el = ref.current;
    if (!el || reduced) return;
    const parent = el.parentElement;
    if (!parent) return;

    let raf = 0;
    let tx = 50, ty = 50;
    let cx = 50, cy = 50;

    const onMove = (e) => {
      const rect = parent.getBoundingClientRect();
      tx = ((e.clientX - rect.left) / rect.width) * 100;
      ty = ((e.clientY - rect.top) / rect.height) * 100;
    };
    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      el.style.background = `radial-gradient(600px circle at ${cx}% ${cy}%, rgba(108,92,231,${intensity}), rgba(75,159,255,${intensity * 0.5}) 30%, transparent 60%)`;
      raf = requestAnimationFrame(tick);
    };

    parent.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(tick);
    return () => {
      parent.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, [reduced, intensity]);

  return (
    <div
      ref={ref}
      aria-hidden
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        background: `radial-gradient(600px circle at 50% 40%, rgba(108,92,231,${intensity}), transparent 60%)`,
        mixBlendMode: 'screen',
        opacity: reduced ? 0.5 : 1,
      }}
    />
  );
}
